import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import { VocabIcon } from '@/components/icons'
export const VocabRoutes: Array<RouteRecordRaw> = [
  {
    path: '/vocabs',
    meta: { middleware: 'auth', requiresPlanAccess: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: 'collections',
        name: 'vocab-collections',
        component: () => import('@/views/vocab/collections-list/index.vue'),
        meta: {
          breadcrumb: [
            {
              text: 'واژگان',
              to: '/vocabs/collections?mode=overview',
              icon: VocabIcon
            }
          ]
        }
      },
      {
        path: 'collections/:collection_name/review',
        name: 'collection_review',
        component: () => import('@/views/vocab/collection-review/index.vue')
      },
      {
        path: 'collections/:collection_name/review/words/:wordID',
        name: 'word_more_detail',
        component: () => import('@/views/vocab/collection-review/[wordID].vue')
      },
      {
        path: 'collections/:collection_name',
        name: 'collection_overview',
        component: () => import('@/views/vocab/collection/collectoin-overview.vue')
      },
      {
        path: 'collections/:collection_name/set-goal',
        name: 'collection_setting_goal',
        component: () => import('@/views/vocab/collection/set-goal.vue')
      },
      {
        path: 'collections/:collection_name/introduction',
        name: 'collection_introduction',
        component: () =>
          import('@/views/vocab/collection/collection-introduction.vue')
      },
      {
        path: 'collections/:collection_name/daily-vocabulary',
        name: 'collection_vocab',
        component: () => import('@/views/vocab/daily-vocabulary/index.vue'),
        meta: {
          title: (route: RouteLocationNormalized) => {
            const name = route.params.collection_name
            return typeof name === 'string' && name.trim() ? name : 'واژگان'
          },
          breadcrumb: []
        }
      }
    ]
  }
]
